import { lazy } from 'react';

const ChatAppConfig = {
  settings: {
    layout: {
      config: {},
    },
  },
  routes: [
    {
      path: '/inspections',
      component: lazy(() => import('./NewInspectionApp')),
    },
  ],
};

export default ChatAppConfig;
